(() => {
  const loader = document.currentScript;
  const pageType = loader?.dataset.adwoaPageType || '';
  if (pageType === 'password' || pageType === 'index') return;

  const MOBILE = '(max-width: 989px)';
  const isCollection = pageType === 'collection' || !!document.getElementById('ProductGridContainer');
  const pathname = location.pathname.replace(/\/$/, '') || '/';
  const active = (path) => pathname === path ? ' is-active' : '';

  const css = `
    .adwoa-mobile-shell{display:none}
    @media(max-width:989px){
      .mobile-header,header-drawer.mobile-header,.desktop-header{display:none!important}
      .adwoa-mobile-shell{position:fixed;top:27px;left:18px;right:18px;z-index:2147481900;display:block;height:24px;color:#000;font:400 13px/1 "Times New Roman",Times,serif;letter-spacing:.08em;text-transform:uppercase;pointer-events:none}
      .adwoa-mobile-shell *{box-sizing:border-box}
      .adwoa-mobile-menu-toggle{position:absolute;left:0;top:0;z-index:5;display:flex;width:auto;height:24px;align-items:center;justify-content:flex-start;margin:0;padding:0;border:0;background:transparent;pointer-events:auto;cursor:pointer;-webkit-appearance:none;appearance:none}
      .adwoa-mobile-menu-toggle__label{display:block}
      .adwoa-mobile-menu-toggle__close{display:none;font:inherit;letter-spacing:inherit}
      .adwoa-mobile-shell .adwoa-mobile-menu-toggle,.adwoa-mobile-shell .adwoa-mobile-filter__trigger,.adwoa-mobile-shell .adwoa-mobile-bag{font-family:HelveticaNeue-CondensedBold,"Helvetica Neue Condensed Bold","Arial Narrow","Helvetica Neue",Helvetica,Arial,sans-serif!important;font-size:16px!important;font-weight:800!important;line-height:1!important;letter-spacing:.04em!important}
      .adwoa-mobile-shell.is-menu-open .adwoa-mobile-menu-toggle__label{display:none}
      .adwoa-mobile-shell.is-menu-open .adwoa-mobile-menu-toggle__close{display:block}
      .adwoa-mobile-actions{position:absolute;right:0;top:0;display:flex;height:24px;align-items:center;gap:18px;pointer-events:auto}
      .adwoa-mobile-shell a,.adwoa-mobile-shell button,.adwoa-mobile-filter__option{color:#000!important;font:400 13px/1.2 "Times New Roman",Times,serif!important;letter-spacing:.08em!important;text-transform:uppercase!important;text-decoration:none!important}
      .adwoa-mobile-shell button{min-width:0!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;box-shadow:none!important;-webkit-appearance:none!important;appearance:none!important}
      .adwoa-mobile-bag,.adwoa-mobile-filter__trigger{display:inline-flex;height:24px;align-items:center;white-space:nowrap}
      .adwoa-mobile-filter__dropdown{position:absolute;top:36px;z-index:3;display:none;margin:0;border:0;background:#fff;color:#000;box-shadow:none;pointer-events:auto}
      .adwoa-mobile-menu-panel{position:fixed;inset:0;z-index:3;display:none;width:100vw;height:100dvh;min-height:100vh;margin:0;padding:8rem 2.8rem 4rem;border:0;background:#fff;color:#000;box-shadow:none;overflow-y:auto;pointer-events:auto;-webkit-overflow-scrolling:touch}
      .adwoa-mobile-shell.is-menu-open .adwoa-mobile-menu-panel{display:flex;align-items:center;justify-content:center}
      .adwoa-mobile-shell.is-menu-open .adwoa-mobile-actions{display:none}
      .adwoa-mobile-menu-panel nav{width:100%}
      .adwoa-mobile-menu__list{display:flex;flex-direction:column;align-items:center;margin:0;padding:0;list-style:none;text-align:center}
      .adwoa-mobile-menu__row{display:block;width:100%;margin:0;padding:0}
      .adwoa-mobile-menu__list{gap:20px}
      .adwoa-mobile-shell .adwoa-mobile-menu__link{display:block!important;width:max-content!important;margin-inline:auto!important;padding:0!important;white-space:nowrap;text-align:center;cursor:pointer;font-family:var(--font-body-family)!important;font-size:30px!important;font-weight:800!important;line-height:1!important;letter-spacing:0!important}
      .adwoa-mobile-menu__link:hover,.adwoa-mobile-menu__link:active,.adwoa-mobile-menu__link.is-active{opacity:.5!important;text-decoration:none!important}
      .adwoa-mobile-filter__sort.is-selected,.adwoa-mobile-filter__option input:checked+span{text-decoration:underline!important;text-underline-offset:4px!important}
      .adwoa-mobile-filter-menu{position:relative;display:inline-flex;height:24px;align-items:center}
      .adwoa-mobile-filter__trigger{cursor:pointer}
      .adwoa-mobile-filter__dropdown{top:96px;right:0;width:min(78vw,280px);max-height:calc(100dvh - 142px);overflow-y:auto;padding:15px 16px 18px;-webkit-overflow-scrolling:touch}
      .adwoa-mobile-shell.is-filter-open .adwoa-mobile-filter__dropdown{display:block}
      .adwoa-mobile-filter__form,.adwoa-mobile-filter__group,.adwoa-mobile-filter__options{display:flex;flex-direction:column;align-items:flex-start}
      .adwoa-mobile-filter__form{gap:20px;margin:0;padding:0}.adwoa-mobile-filter__group{width:100%;gap:8px}.adwoa-mobile-filter__options{gap:7px}
      .adwoa-mobile-filter__title{display:block;font-weight:700;white-space:nowrap}
      .adwoa-mobile-filter__sort,.adwoa-mobile-filter__clear,.adwoa-mobile-filter__option{position:relative;display:inline-flex!important;width:fit-content!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;white-space:nowrap;cursor:pointer}
      .adwoa-mobile-filter__option input{position:absolute;width:1px;height:1px;opacity:0;pointer-events:none}.adwoa-mobile-filter__option.is-disabled{pointer-events:none;opacity:.4}.adwoa-mobile-filter__clear{opacity:.5}
      .adwoa-mobile-shell :focus,.adwoa-mobile-shell :focus-visible{outline:0!important;box-shadow:none!important}
      html.adwoa-mobile-menu-lock,html.adwoa-mobile-menu-lock body{overflow:hidden!important;overscroll-behavior:none}
      #main-collection-filters .mobile-facets__open-wrapper,#main-collection-filters .mobile-facets,#main-collection-filters .active-facets,#main-collection-filters .active-facets-mobile,#main-collection-filters .active-facets-desktop,#main-collection-filters .active-facets__button-wrapper{display:none!important}
    }
    @media(max-width:749px){#ProductGridContainer #product-grid>.grid__item{flex:0 0 calc((100% - var(--grid-mobile-horizontal-spacing))/2)!important;width:calc((100% - var(--grid-mobile-horizontal-spacing))/2)!important;max-width:calc((100% - var(--grid-mobile-horizontal-spacing))/2)!important}}
    @media(min-width:750px) and (max-width:989px){#ProductGridContainer #product-grid>.grid__item{flex:0 0 calc((100% - var(--grid-desktop-horizontal-spacing))/2)!important;width:calc((100% - var(--grid-desktop-horizontal-spacing))/2)!important;max-width:calc((100% - var(--grid-desktop-horizontal-spacing))/2)!important}}
  `;

  const installStyle = () => {
    document.getElementById('AdwoaMobileInterfaceStyles')?.remove();
    const style = document.createElement('style');
    style.id = 'AdwoaMobileInterfaceStyles';
    style.textContent = css;
    document.head.appendChild(style);
  };

  const resetNative = () => {
    if (!matchMedia(MOBILE).matches) return;
    document.querySelectorAll('.mobile-header details[open]').forEach((d) => {
      d.removeAttribute('open');
      d.classList.remove('menu-opening');
      d.querySelector('summary')?.setAttribute('aria-expanded','false');
    });
    document.documentElement.classList.remove('overflow-hidden-mobile','overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-mobile','overflow-hidden-tablet');
  };

  const go = (params) => {
    params.delete('page');
    const q = params.toString();
    location.assign(q ? `${location.pathname}?${q}` : location.pathname);
  };

  const sourceLabel = (form,input) => {
    const label = input.closest('li')?.querySelector('label') || (input.id ? form?.querySelector(`label[for="${input.id}"]`) : null);
    return (label?.textContent || input.value || '').replace(/\s+/g,' ').trim();
  };

  const groupTitle = (group) => (group?.querySelector('.mobile-facets__summary span,.facets__summary span,summary span')?.textContent || '').replace(/\s+/g,' ').trim().toUpperCase();

  const choice = (form,src,text) => {
    const label = document.createElement('label');
    label.className = `adwoa-mobile-filter__option${src.disabled ? ' is-disabled' : ''}`;
    const input = document.createElement('input');
    input.type = src.type;
    input.name = src.name;
    input.value = src.value;
    input.checked = src.checked;
    input.disabled = src.disabled;
    const span = document.createElement('span');
    span.textContent = text;
    label.append(input,span);
    return label;
  };

  const buildFilter = (host) => {
    const source = document.querySelector('#FacetFiltersFormMobile') || document.querySelector('#FacetFiltersForm');
    const groups = source ? [...source.querySelectorAll('.js-filter')] : [];
    const params = new URLSearchParams(location.search);
    const form = document.createElement('form');
    form.className = 'adwoa-mobile-filter__form';

    const makeGroup = (title) => {
      const group = document.createElement('div');
      group.className = 'adwoa-mobile-filter__group';
      const heading = document.createElement('span');
      heading.className = 'adwoa-mobile-filter__title';
      heading.textContent = title;
      const options = document.createElement('div');
      options.className = 'adwoa-mobile-filter__options';
      group.append(heading,options);
      form.appendChild(group);
      return options;
    };

    const sort = makeGroup('SORT');
    const currentSort = params.get('sort_by') || '';
    [
      ['RECOMMENDED',''],
      ['NEWEST','created-descending'],
      ['PRICE: LOW TO HIGH','price-ascending'],
      ['PRICE: HIGH TO LOW','price-descending']
    ].forEach(([label,value]) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'adwoa-mobile-filter__sort';
      b.textContent = label;
      if (value ? currentSort === value : currentSort === '' || currentSort === 'manual') b.classList.add('is-selected');
      b.addEventListener('click',() => {
        const p = new URLSearchParams(location.search);
        value ? p.set('sort_by',value) : p.delete('sort_by');
        go(p);
      });
      sort.appendChild(b);
    });

    [['SIZE','SIZE'],['AVAILABILITY','AVAILABILITY']].forEach(([title,needle]) => {
      if (!source) return;
      const srcGroup = groups.find((g) => groupTitle(g).includes(needle));
      if (!srcGroup) return;
      let inputs = [...srcGroup.querySelectorAll('input[name^="filter."]')].filter((i) => i.type === 'checkbox' || i.type === 'radio');
      if (title === 'AVAILABILITY') inputs = inputs.filter((i) => {
        const t = sourceLabel(source,i).toUpperCase();
        return t.includes('IN STOCK') && !t.includes('OUT OF STOCK');
      });
      if (!inputs.length) return;
      const options = makeGroup(title);
      inputs.forEach((src) => options.appendChild(choice(source,src,title === 'AVAILABILITY' ? 'IN STOCK' : String(src.value || sourceLabel(source,src)).replace(/\s+/g,' ').trim().toUpperCase())));
    });

    if ([...params.keys()].some((k) => k.startsWith('filter.')) || params.has('sort_by')) {
      const clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'adwoa-mobile-filter__clear';
      clear.textContent = 'CLEAR';
      clear.addEventListener('click',() => {
        const p = new URLSearchParams(location.search);
        [...p.keys()].forEach((k) => { if (k.startsWith('filter.') || k === 'sort_by' || k === 'page') p.delete(k); });
        go(p);
      });
      form.appendChild(clear);
    }

    form.addEventListener('change',() => {
      const p = new URLSearchParams(location.search);
      [...p.keys()].forEach((k) => { if (k.startsWith('filter.') || k === 'page') p.delete(k); });
      new FormData(form).forEach((value,key) => { if (String(value).trim()) p.append(key,String(value).trim()); });
      go(p);
    });
    form.addEventListener('submit',(e) => e.preventDefault());
    host.replaceChildren(form);
  };

  const createShell = () => {
    document.getElementById('AdwoaMobileShell')?.remove();
    const shell = document.createElement('div');
    shell.id = 'AdwoaMobileShell';
    shell.className = 'adwoa-mobile-shell';
    shell.innerHTML = `
      <button type="button" class="adwoa-mobile-menu-toggle" data-burger aria-label="Open menu" aria-expanded="false"><span class="adwoa-mobile-menu-toggle__label">SHOP</span><span class="adwoa-mobile-menu-toggle__close" aria-hidden="true">X</span></button>
      <div class="adwoa-mobile-menu-panel" data-menu>
        <nav aria-label="Mobile navigation"><ul class="adwoa-mobile-menu__list">
          <li class="adwoa-mobile-menu__row"><a href="/collections/mainline" class="adwoa-mobile-menu__link${active('/collections/mainline')}">MAINLINE</a></li>
          <li class="adwoa-mobile-menu__row"><a href="/collections/philosophy" class="adwoa-mobile-menu__link${active('/collections/philosophy')}">PHILOSOPHY</a></li>
          <li class="adwoa-mobile-menu__row"><a href="/collections/all" class="adwoa-mobile-menu__link${active('/collections/all')}">SHOP ALL</a></li>
          <li class="adwoa-mobile-menu__row"><a href="/pages/appointment" class="adwoa-mobile-menu__link${active('/pages/appointment')}">SHOWROOM</a></li>
        </ul></nav>
      </div>
      <div class="adwoa-mobile-actions">
        ${isCollection ? '<div class="adwoa-mobile-filter-menu"><button type="button" class="adwoa-mobile-filter__trigger" data-filter aria-expanded="false">FILTER</button><div class="adwoa-mobile-filter__dropdown" data-filter-panel></div></div>' : ''}
        <a href="/cart" class="adwoa-mobile-bag" data-bag>BAG (0)</a>
      </div>`;
    document.body.appendChild(shell);
    return shell;
  };

  const setup = () => {
    installStyle();
    resetNative();
    const shell = createShell();
    const burger = shell.querySelector('[data-burger]');
    const filter = shell.querySelector('[data-filter]');
    const filterPanel = shell.querySelector('[data-filter-panel]');
    const bag = shell.querySelector('[data-bag]');

    fetch('/cart.js',{credentials:'same-origin'}).then((r) => r.ok ? r.json() : null).then((cart) => {
      if (!cart || !Number.isFinite(cart.item_count)) return;
      bag.textContent = `BAG (${cart.item_count})`;
      bag.setAttribute('aria-label',`Bag, ${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`);
    }).catch(() => {});

    const menuOpen = (open) => {
      shell.classList.toggle('is-menu-open',open);
      burger?.setAttribute('aria-expanded',open ? 'true' : 'false');
      burger?.setAttribute('aria-label',open ? 'Close menu' : 'Open menu');
      document.documentElement.classList.toggle('adwoa-mobile-menu-lock',open);
      if (open) filterOpen(false);
    };
    const filterOpen = (open) => {
      if (!filter || !filterPanel) return;
      if (open) buildFilter(filterPanel);
      shell.classList.toggle('is-filter-open',open);
      filter.setAttribute('aria-expanded',open ? 'true' : 'false');
      if (open) menuOpen(false);
    };

    burger?.addEventListener('click',(e) => { e.stopPropagation(); menuOpen(!shell.classList.contains('is-menu-open')); });
    filter?.addEventListener('click',(e) => { e.stopPropagation(); filterOpen(!shell.classList.contains('is-filter-open')); });
    shell.addEventListener('click',(e) => e.stopPropagation());
    document.addEventListener('click',() => { menuOpen(false); filterOpen(false); });
    document.addEventListener('keydown',(e) => { if (e.key === 'Escape') { menuOpen(false); filterOpen(false); } });
    resetNative();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true});
  else setup();
  document.addEventListener('shopify:section:load',setup);
})();
